<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  count: {
    type: Number,
    default: 0,
  },
  // Contagem parou no teto do servidor: mostra "N+" (ConversationCounts).
  countCapped: {
    type: Boolean,
    default: false,
  },
  showBadge: {
    type: Boolean,
    default: true,
  },
  isCompact: {
    type: Boolean,
    default: false,
  },
  // Icon Lucide (ex: 'i-lucide-settings'). Aparece a esquerda do nome.
  // Padrao ClickUp: ícone + label, ambos colorindo juntos no estado ativo.
  icon: {
    type: String,
    default: '',
  },
});

const activeIndex = inject('activeIndex');
const updateActiveIndex = inject('updateActiveIndex');
// Quando o woot-tabs pai está em modo fit, a tab encolhe e trunca o label
// pra caber (sem setas < >). Fora do fit, comportamento original.
const tabsFit = inject('tabsFit', false);

const active = computed(() => props.index === activeIndex.value);
const getItemCount = computed(() =>
  props.countCapped ? `${props.count}+` : props.count
);

const onTabClick = event => {
  event.preventDefault();
  if (!props.disabled) {
    updateActiveIndex(props.index);
  }
};
</script>

<template>
  <li
    class="my-0 mx-3 ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0 hover:text-n-slate-12"
    :class="tabsFit ? 'min-w-0' : 'flex-shrink-0'"
  >
    <a
      class="inline-flex items-center gap-1.5 border-b-2 select-none cursor-pointer relative top-[1px] transition-[border-color,color] duration-150 ease-[cubic-bezier(0.37,0,0.63,1)]"
      :class="[
        active
          ? 'border-n-brand-ink text-n-blue-text font-medium'
          : 'border-transparent text-n-slate-11',
        isCompact ? 'py-2 text-sm' : 'text-base py-3',
        tabsFit ? 'max-w-full min-w-0' : '',
      ]"
      @click="onTabClick"
    >
      <span
        v-if="icon"
        class="shrink-0"
        :class="[icon, isCompact ? 'size-4' : 'size-4']"
      />
      <span
        v-tooltip.top="tabsFit ? name : ''"
        :class="tabsFit ? 'truncate' : ''"
      >
        {{ name }}
      </span>
      <div
        v-if="showBadge"
        class="rounded-md h-5 flex items-center justify-center shrink-0 text-xxs font-semibold my-0 mx-1 px-1 py-0 min-w-[20px]"
        :class="[
          active
            ? 'bg-n-brand/10 dark:bg-n-brand/20 text-n-blue-text'
            : 'bg-n-alpha-black2 dark:bg-n-solid-3 text-n-slate-11',
        ]"
      >
        <span>
          {{ getItemCount }}
        </span>
      </div>
    </a>
  </li>
</template>
